import { combineReducers } from "redux";
import {
  REQUEST_ASSETS,
  RECEIVE_ASSETS,
} from "@actions/action_consts";

const pages = (pages = {}, action = {}) => {
  Object.freeze(pages)
  switch (action.type) {
    case REQUEST_ASSETS:
      return {
        ...pages,
        [action.params.page]: {
          items: [],
          fetching: true,
        },
      };
    case RECEIVE_ASSETS:
      let list = action.assets.list;
      return {
        ...pages,
        [action.params.page]: {
          items: list?.map((item) => item.id),
          fetching: false,
        },
      };

    default:
      return pages;
  }
};

const filter = (filter = {}, action = {}) => 
  action.type === REQUEST_ASSETS ? (action.params.filter || {}) : filter;
const currentPage = (currentPage = 1, action = {}) =>
  action.type === REQUEST_ASSETS ? (action.params.page || 1) : currentPage;
const total = (total = 0, action = {}) =>
  action.type === RECEIVE_ASSETS ? action.assets.total : total;


export const assetsPagination = combineReducers({
  pages,
  currentPage,
  total,
  filter
});
